var React = require('react');

function IconLink (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("polygon",{"points":"20.002,21.234 3.002,21.234 3.002,4.234 11.002,4.234 11.002,6.234 5.002,6.234 5.002,19.234 18.002,19.234 \r\n\t\t18.002,13.234 20.002,13.234 \t","key":0}),React.createElement("polygon",{"points":"20.998,9.766 18.998,9.766 18.998,4.765 13.998,4.765 13.998,2.766 20.998,2.766 \t","key":1}),React.createElement("rect",{"x":"15.697","y":"2.402","transform":"matrix(0.7071 0.7071 -0.7071 0.7071 10.0032 -9.689)","width":"2","height":"9.658","key":2})]));
}

IconLink.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"24px","height":"24px","viewBox":"0 0 24 24","enableBackground":"new 0 0 24 24","xmlSpace":"preserve"};

module.exports = IconLink;

IconLink.default = IconLink;
